export const SET_UTILITY_IMPORT_DATA = 'SET_UTILITY_IMPORT_DATA'
export const SET_REBATE_IMPORT_DATA = 'SET_REBATE_IMPORT_DATA'
export const SET_PROGRAM_IMPORT_DATA = 'SET_PROGRAM_IMPORT_DATA'
